module.exports = __webpack_public_path__ + "img/713-3713c0.png";